module.exports = __webpack_public_path__ + "static/img/v_1.d06b44ce.png";